import { render, staticRenderFns } from "./RelationInput.vue?vue&type=template&id=4c48a1cc"
import script from "./RelationInput.vue?vue&type=script&lang=js"
export * from "./RelationInput.vue?vue&type=script&lang=js"
import style0 from "./RelationInput.vue?vue&type=style&index=0&id=4c48a1cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports